import { render, staticRenderFns } from "./TestCard.vue?vue&type=template&id=9f275d5e&scoped=true"
import script from "./TestCard.vue?vue&type=script&lang=js"
export * from "./TestCard.vue?vue&type=script&lang=js"
import style0 from "./TestCard.vue?vue&type=style&index=0&id=9f275d5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f275d5e",
  null
  
)

export default component.exports